__turbopack_context__.v({
  "btn": "index-module-scss-module__I2P_lG__btn",
  "btn--blue": "index-module-scss-module__I2P_lG__btn--blue",
  "btn--dark": "index-module-scss-module__I2P_lG__btn--dark",
  "btn--full-width": "index-module-scss-module__I2P_lG__btn--full-width",
  "btn--green": "index-module-scss-module__I2P_lG__btn--green",
  "btn--has-only-icon": "index-module-scss-module__I2P_lG__btn--has-only-icon",
  "btn--large": "index-module-scss-module__I2P_lG__btn--large",
  "btn--light": "index-module-scss-module__I2P_lG__btn--light",
  "btn--medium": "index-module-scss-module__I2P_lG__btn--medium",
  "btn--primary": "index-module-scss-module__I2P_lG__btn--primary",
  "btn--red": "index-module-scss-module__I2P_lG__btn--red",
  "btn--reversed-green": "index-module-scss-module__I2P_lG__btn--reversed-green",
  "btn--reversed-primary": "index-module-scss-module__I2P_lG__btn--reversed-primary",
  "btn--rounded": "index-module-scss-module__I2P_lG__btn--rounded",
  "btn--small": "index-module-scss-module__I2P_lG__btn--small",
  "btn--transparent": "index-module-scss-module__I2P_lG__btn--transparent",
});
